import React, { Component } from 'react';
import Events from '../../common/events';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import { strings } from '../../../localization';
import moment from 'moment';

export default class EditPlanSection extends Component {

    constructor(props) {

        super(props);
        this.state = {
            errorMessage: null
        };
    }

    submitServicePlan = (e) => {

        e.preventDefault();
        var planTitle = this.props.targetPlanCode;
        if (strings["plan_title_" + this.props.targetPlanCode]) planTitle = strings.formatString(strings["plan_title_" + this.props.targetPlanCode]);
        var loadingScreenMessage = "Subscribing to " + planTitle;
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: loadingScreenMessage } }));
        try {
            if (this.props.subscription) {
                LambdaUtil.updateServicePlan(this.props.user.stage, this.props.targetPlanCode, this.props.subscription.subscriptionUuid, this.onSubscriptionSuccess, this.onSubscriptionFail);
            } else {
                LambdaUtil.subscribeServicePlan(this.props.user.stage, this.props.targetPlanCode, this.props.raven.ravenUuid, this.onSubscriptionSuccess, this.onSubscriptionFail);
            }
        } catch (e) {
            console.error(e);
            this.onSubscriptionFail();
        }
    }

    onSubscriptionSuccess = (data) => {

        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR') {
            if (payload.message.indexOf('Unknown') > -1) //TODO LOC BILLING
                this.genericError();
            else this.setState({
                errorMessage: payload.message
            });
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            return;
        } else {
            document.documentElement.classList.remove("no-scroll");
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: "Subscription Successful", style: 'success', 'override': true } }));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
            return;
        }
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onSubscriptionFail = (err) => {

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.genericError();
    }

    genericError() {

        this.setState({
            errorMessage: strings.formatString(strings.account_error_upate_sub)
        }, () => {
            this.props.refreshAccountDetails(); //just in case something changed
        })
    }

    render() {

        var isUpgrade = this.props.subscription && parseInt(this.props.recurlyPricing.next.plan) * 100 >= this.props.subscription.amountInCents ? true : false;
        var isStartSub = !this.props.subscription || (this.props.subscription && this.props.subscription.state === 'canceled') ? true : false;
        var nextPlan = undefined;
        if (this.props.accountDetails) {
            nextPlan = this.props.accountDetails.subscriptions.find(plan => {
                return plan.state === "pending" && plan.subscriptionUuid === this.props.subscription.subscriptionUuid
            });
        }
        var sameAsCurrent = this.props.subscription && nextPlan && this.props.subscription.planCode === nextPlan.planCode;
        var message = null;
        if (sameAsCurrent) {
            message = <div>
                <p>{strings.raven_subscription_you_will_remain_on_current_plan_without_changing_at_your_next_billing_cycle}</p>
                <table className="pricing-table">
                    <tbody>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_now_label}</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>0.00 {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_next_billing_cycle} {this.props.subscription ? '(' + moment(this.props.subscription.currentBillingPeriod.end).format("LL") + ')' : null})</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>{this.props.recurlyPricing.next.total} {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        } else if (isUpgrade) {
            message = <div>
                <p>{strings.raven_subscription_you_will_be_able_to_use_this_plan_immediately}</p>
                <table className="pricing-table">
                    <tbody>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_now_label}</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>0.00 {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_next_billing_cycle} ({this.props.subscription ? '(' + moment(this.props.subscription.currentBillingPeriod.end).format("LL") + ')' : null})</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>{this.props.recurlyPricing.next.total} {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        } else if (isStartSub) {
            message = <div>
                <p>{strings.raven_subscription_you_will_be_able_to_use_your_new_plan_immediately}</p>
                <table className="pricing-table">
                    <tbody>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_now_label}</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>{this.props.recurlyPricing.next.total} {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_next_billing_cycle} ({this.props.subscription ? '(' + moment(this.props.subscription.currentBillingPeriod.end).format("LL") + ')' : null})</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>{this.props.recurlyPricing.next.total} {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        } else {//downgrade
            message = <div>
                <p>{strings.raven_subscription_you_are_about_to_downgrade_your_plan}</p>
                <p>{strings.raven_subscription_the_change_will_take_effect_at_the_end_of_your_current_billing_cycle} ({this.props.subscription ? '(' + moment(this.props.subscription.currentBillingPeriod.end).format("LL") + ')' : null}).</p>
                <table className="pricing-table">
                    <tbody>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_now_label}</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>0.00 {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                        <tr>
                            <td><label htmlFor="">{strings.raven_subscription_due_next_billing_cycle} ({'(' + moment(this.props.subscription.currentBillingPeriod.end).format("LL") + ')'})</label></td>
                            <td><span className="currency-symbol">{this.props.recurlyPricing.currency.symbol}</span><span>{this.props.recurlyPricing.next.total} {this.props.recurlyPricing.currency.code}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        }

        var planTitle = this.props.targetPlanCode;
        if (strings["plan_title_" + this.props.targetPlanCode]) planTitle = strings.formatString(strings["plan_title_" + this.props.targetPlanCode]);
        return (
            <div className="col-12 content-group">
                <div className="row">
                    <div className="col-12">
                        <h2><i className="material-icons">edit</i> {strings.raven_subscription_youre_about_to_subscribe_to} <span className="blue">{planTitle}</span></h2>
                        {message}
                    </div>
                    <div className="col-12 action-btns">
                        <button className="btn btn-outline-blue" onClick={this.props.goBack}><i className="material-icons">close</i>{strings.action_cancel}</button>
                        <button className="btn" id="submitBtn" onClick={this.submitServicePlan}><i className="material-icons">check</i>{strings.action_continue}</button>
                    </div>
                    <div className="col-12">
                        {this.state.errorMessage ? <p className="red"><i className="material-icons">error_outline</i>{this.props.suscriptionErrorMessage}</p> : null}
                    </div>
                </div>
            </div>
        )
    }
}
